import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bper-logout',
  templateUrl: './bper-logout.component.html',
  styleUrls: ['./bper-logout.component.css'],
})
export class BperLogoutComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
